/* eslint-disable */ import { composedOfComponent, memoEval, sceneEntityDeleteFabComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const deckItemComponents = [
    attachComponent.withComponent(composedOfComponent, '$projectedEntities', true).withAlias('DeckItem').attach(memoEval((self)=>self.$projectedEntities.map((entity)=>entity.id), (...ids)=>({
            childEntityIds: ids
        }))),
    attachComponent.withComponent(sceneEntityDeleteFabComponent, 'default', true).withAlias('DeckItem').withGradualFilter({
        viewStates: [
            'FloorPlan'
        ]
    }).attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$deleteFab
        ], ($deleteFab)=>$deleteFab))
];

//# sourceMappingURL=deck-item.js.map